import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// EN
import commonEN from './locales/en/common.json';
import accountEN from './locales/en/account.json';
import funnelEN from './locales/en/funnel.json';
import tasksEN from './locales/en/tasks.json';
import recordingEN from './locales/en/recording.json';
import listsEN from './locales/en/lists.json';
import teamEN from './locales/en/team.json';
import quotasEN from './locales/en/quotas.json';
import scriptsEN from './locales/en/scripts.json';
import engagementsEN from './locales/en/engagements.json';
import messagesEN from './locales/en/messages.json';
import chatEN from './locales/en/chat.json';
import analyticsEN from './locales/en/analytics.json';
import paywallEN from './locales/en/paywall.json';
import faqEN from './locales/en/faq.json';
import adminEN from './locales/en/admin.json';
import companiesEN from './locales/en/companies.json';
import contactsEN from './locales/en/contacts.json';
import signalsEN from './locales/en/signals.json';
import postsEN from './locales/en/posts.json';

// ES
import commonES from './locales/es/common.json';
import accountES from './locales/es/account.json';
import funnelES from './locales/es/funnel.json';
import tasksES from './locales/es/tasks.json';
import recordingES from './locales/es/recording.json';
import listsES from './locales/es/lists.json';
import teamES from './locales/es/team.json';
import quotasES from './locales/es/quotas.json';
import scriptsES from './locales/es/scripts.json';
import engagementsES from './locales/es/engagements.json';
import messagesES from './locales/es/messages.json';
import chatES from './locales/es/chat.json';
import analyticsES from './locales/es/analytics.json';
import paywallES from './locales/es/paywall.json';
import faqES from './locales/es/faq.json';
import adminES from './locales/es/admin.json';
import companiesES from './locales/es/companies.json';
import contactsES from './locales/es/contacts.json';
import signalsES from './locales/es/signals.json';
import postsES from './locales/es/posts.json';

// PT
import commonPT from './locales/pt/common.json';
import accountPT from './locales/pt/account.json';
import funnelPT from './locales/pt/funnel.json';
import tasksPT from './locales/pt/tasks.json';
import recordingPT from './locales/pt/recording.json';
import listsPT from './locales/pt/lists.json';
import teamPT from './locales/pt/team.json';
import quotasPT from './locales/pt/quotas.json';
import scriptsPT from './locales/pt/scripts.json';
import engagementsPT from './locales/pt/engagements.json';
import messagesPT from './locales/pt/messages.json';
import chatPT from './locales/pt/chat.json';
import analyticsPT from './locales/pt/analytics.json';
import paywallPT from './locales/pt/paywall.json';
import faqPT from './locales/pt/faq.json';
import adminPT from './locales/pt/admin.json';
import companiesPT from './locales/pt/companies.json';
import contactsPT from './locales/pt/contacts.json';
import signalsPT from './locales/pt/signals.json';
import postsPT from './locales/pt/posts.json';

// FR
import commonFR from './locales/fr/common.json';
import accountFR from './locales/fr/account.json';
import funnelFR from './locales/fr/funnel.json';
import tasksFR from './locales/fr/tasks.json';
import recordingFR from './locales/fr/recording.json';
import listsFR from './locales/fr/lists.json';
import teamFR from './locales/fr/team.json';
import quotasFR from './locales/fr/quotas.json';
import scriptsFR from './locales/fr/scripts.json';
import engagementsFR from './locales/fr/engagements.json';
import messagesFR from './locales/fr/messages.json';
import chatFR from './locales/fr/chat.json';
import analyticsFR from './locales/fr/analytics.json';
import paywallFR from './locales/fr/paywall.json';
import faqFR from './locales/fr/faq.json';
import adminFR from './locales/fr/admin.json';
import companiesFR from './locales/fr/companies.json';
import contactsFR from './locales/fr/contacts.json';
import signalsFR from './locales/fr/signals.json';
import postsFR from './locales/fr/posts.json';

// DE
import commonDE from './locales/de/common.json';
import accountDE from './locales/de/account.json';
import funnelDE from './locales/de/funnel.json';
import tasksDE from './locales/de/tasks.json';
import recordingDE from './locales/de/recording.json';
import listsDE from './locales/de/lists.json';
import teamDE from './locales/de/team.json';
import quotasDE from './locales/de/quotas.json';
import scriptsDE from './locales/de/scripts.json';
import engagementsDE from './locales/de/engagements.json';
import messagesDE from './locales/de/messages.json';
import chatDE from './locales/de/chat.json';
import analyticsDE from './locales/de/analytics.json';
import paywallDE from './locales/de/paywall.json';
import faqDE from './locales/de/faq.json';
import adminDE from './locales/de/admin.json';
import companiesDE from './locales/de/companies.json';
import contactsDE from './locales/de/contacts.json';
import signalsDE from './locales/de/signals.json';
import postsDE from './locales/de/posts.json';

const resources = {
  en: {
    common: commonEN,
    account: accountEN,
    funnel: funnelEN,
    tasks: tasksEN,
    recording: recordingEN,
    lists: listsEN,
    team: teamEN,
    quotas: quotasEN,
    scripts: scriptsEN,
    engagements: engagementsEN,
    messages: messagesEN,
    chat: chatEN,
    analytics: analyticsEN,
    paywall: paywallEN,
    faq: faqEN,
    admin: adminEN,
    companies: companiesEN,
    contacts: contactsEN,
    signals: signalsEN,
    posts: postsEN,
  },
  es: {
    common: commonES,
    account: accountES,
    funnel: funnelES,
    tasks: tasksES,
    recording: recordingES,
    lists: listsES,
    team: teamES,
    quotas: quotasES,
    scripts: scriptsES,
    engagements: engagementsES,
    messages: messagesES,
    chat: chatES,
    analytics: analyticsES,
    paywall: paywallES,
    faq: faqES,
    admin: adminES,
    companies: companiesES,
    contacts: contactsES,
    signals: signalsES,
    posts: postsES,
  },
  pt: {
    common: commonPT,
    account: accountPT,
    funnel: funnelPT,
    tasks: tasksPT,
    recording: recordingPT,
    lists: listsPT,
    team: teamPT,
    quotas: quotasPT,
    scripts: scriptsPT,
    engagements: engagementsPT,
    messages: messagesPT,
    chat: chatPT,
    analytics: analyticsPT,
    paywall: paywallPT,
    faq: faqPT,
    admin: adminPT,
    companies: companiesPT,
    contacts: contactsPT,
    signals: signalsPT,
    posts: postsPT,
  },
  fr: {
    common: commonFR,
    account: accountFR,
    funnel: funnelFR,
    tasks: tasksFR,
    recording: recordingFR,
    lists: listsFR,
    team: teamFR,
    quotas: quotasFR,
    scripts: scriptsFR,
    engagements: engagementsFR,
    messages: messagesFR,
    chat: chatFR,
    analytics: analyticsFR,
    paywall: paywallFR,
    faq: faqFR,
    admin: adminFR,
    companies: companiesFR,
    contacts: contactsFR,
    signals: signalsFR,
    posts: postsFR,
  },
  de: {
    common: commonDE,
    account: accountDE,
    funnel: funnelDE,
    tasks: tasksDE,
    recording: recordingDE,
    lists: listsDE,
    team: teamDE,
    quotas: quotasDE,
    scripts: scriptsDE,
    engagements: engagementsDE,
    messages: messagesDE,
    chat: chatDE,
    analytics: analyticsDE,
    paywall: paywallDE,
    faq: faqDE,
    admin: adminDE,
    companies: companiesDE,
    contacts: contactsDE,
    signals: signalsDE,
    posts: postsDE,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'common', 'account', 'funnel', 'tasks', 'recording', 'lists', 'team',
      'quotas', 'scripts', 'engagements', 'messages', 'chat',
      'analytics', 'paywall', 'faq', 'admin', 'companies', 'contacts', 'signals',
    ],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'stackbd_language',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
